<template xmlns="http://www.w3.org/1999/html">
  <div v-if="authenticatedUser">
    <b-container>
      <div class="mt-5 pl-3 pr-3 pb-3 bg-white">
        <b-row class="pl-3 pr-3 pt-4">
          <h3 class="text-left">Register a new ingredient</h3>
        </b-row>
        <hr />
        <b-row>
          <b-col class="my-container" cols-6>
            <b-form>
              <b-form-group>
                <label class="d-block text-left text-bold"
                  >Ingredient title <span class="text-danger">*</span></label
                >
                <b-form-input
                  id="input-1"
                  placeholder="Enter Ingredient Title"
                  v-model="form.title"
                >
                </b-form-input>
                <b-alert
                  dismissible
                  style="width: 100%"
                  v-model="emptyTitleAlert"
                  variant="danger"
                >
                  You have to provide title!
                </b-alert>
              </b-form-group>

              <b-form-group>
                <label class="d-block text-left text-bold"
                  >Description <span class="text-danger">*</span></label
                >
                <textarea
                  class="col-12 form-control"
                  id="recipeDescription"
                  placeholder="Enter Description"
                  rows="4"
                  v-model="form.description"
                >
                </textarea>
                <b-alert
                  dismissible
                  style="width: 100%"
                  v-model="emptyDescriptionAlert"
                  variant="danger"
                >
                  You have to provide a description!
                </b-alert>
              </b-form-group>

              <!--              <b-form-group>-->
              <!--                <label class="d-block text-left text-bold">Type <span class="text-danger">*</span></label>-->
              <!--                <select-->
              <!--                  class="custom-select d-block w-100"-->
              <!--                  v-model="form.resourceType[0]">-->
              <!--                  <option disabled value="">Select Type</option>-->
              <!--                  <option value="CH objects">CH object</option>-->
              <!--                  <option value="Co-creation methodologies and tools">Co-creation methodologies and tool</option>-->
              <!--                  <option value="Digital tools">Digital tool</option>-->
              <!--                  <option value="Impact assessment tools">Impact assessment tool</option>-->
              <!--                  <option value="Past project">Past project</option>-->
              <!--                  <option value="Physical tools">Physical tool</option>-->
              <!--                  <option value="Policy about CH">Policy about CH</option>-->
              <!--                  <option value="Policy about migration">Policy about migration</option>-->
              <!--                  <option value="Training material">Training material</option>-->
              <!--                  <option value="User needs resources">User needs resource</option>-->
              <!--                  <option value="Other">Other (specify)</option>-->
              <!--                </select>-->
              <!--                <b-form-group class="mt-2" v-if="this.form.resourceType.includes('Other')">-->
              <!--                  <label class="d-block text-left text-bold">Please specify</label>-->
              <!--                  <b-form-input-->
              <!--                    placeholder="Enter the type of the ingredient"-->
              <!--                    v-model="additionalType"-->
              <!--                  >-->
              <!--                  </b-form-input>-->
              <!--                </b-form-group>-->
              <!--                <b-alert dismissible style="width: 100%" v-model="emptyTypeAlert" variant="danger">-->
              <!--                  Cannot be empty!-->
              <!--                </b-alert>-->
              <!--              </b-form-group>-->
            </b-form>
          </b-col>

          <b-col>
            <b-form class="mb-2">
              <b-container class="my-container">
                <b-form-group>
                  <label class="d-block text-left text-bold"
                    >Areas of focus <span class="text-danger">*</span> (Hold
                    <strong>Ctrl</strong> to select multiple values)</label
                  >
                  <b-row>
                    <b-col>
                      <b-form-select
                        :options="FocusAreaOptions"
                        style="height: 225px"
                        align="left"
                        label="Form-checkbox-group inline checkboxes (default)"
                        multiple
                        name="flavour-1a"
                        stacked
                        v-model="selectedFocusAreas"
                      >
                      </b-form-select>
                      <b-form-group
                        class="mt-4"
                        v-if="this.selectedFocusAreas.includes('Other')"
                      >
                        <label class="d-block text-left text-bold"
                          >Please specify</label
                        >
                        <b-form-input
                          placeholder="Enter the focus area of the ingredient"
                          v-model="additionalFocusArea"
                        >
                        </b-form-input>
                      </b-form-group>
                    </b-col>

                    <!--                  <b-col>-->
                    <!--                    <b-form-checkbox-group-->
                    <!--                      :options="FocusAreaOptions2"-->
                    <!--                      align="left"-->
                    <!--                      name="flavour-1a"-->
                    <!--                      stacked-->
                    <!--                      v-model="selectedFocusAreas2">-->
                    <!--                    </b-form-checkbox-group>-->
                    <!--                  </b-col>-->
                  </b-row>
                </b-form-group>
              </b-container>

              <b-row>
                <b-alert
                  dismissible
                  style="width: 100%"
                  v-model="emptySelectedFocusAreasAlert"
                  variant="danger"
                >
                  You have to provide at least one focus area!
                </b-alert>
              </b-row>

              <b-container class="my-container text-left">
                <label title="Everybody can see" v-b-tooltip.hover.bottom
                  >Public</label
                >
                <b-form-checkbox
                  checked-value="true"
                  unchecked-value="false"
                  v-model="publicReadable"
                >
                  Yes
                </b-form-checkbox>
              </b-container>
            </b-form>
          </b-col>
        </b-row>

        <hr />
        <br />

        <b-row>
          <b-col cols="6">
            <b-form-group>
              <label class="d-block text-left text-bold"
                >Type <span class="text-danger">*</span> (Hold
                <strong>Ctrl</strong> to select multiple values)</label
              >
              <select
                multiple
                class="custom-select d-block w-100"
                style="height: 202px"
                v-model="form.resourceType"
              >
                <option disabled value="">Select Type</option>
                <option value="CH object">CH object</option>
                <option value="Co-creation methodologies and tool">
                  Co-creation methodologies and tool
                </option>
                <option value="Digital tool">Digital tool</option>
                <option value="Impact assessment tool">
                  Impact assessment tool
                </option>
                <option value="Past project">Past project</option>
                <option value="Physical tools">Physical tool</option>
                <option value="Policy about CH">Policy about CH</option>
                <option value="Policy about migration">
                  Policy about migration
                </option>
                <option value="Training material">Training material</option>
                <option value="User needs resource">User needs resource</option>
                <option value="Other">Other (specify)</option>
              </select>
              <b-form-group
                class="mt-2"
                v-if="this.form.resourceType.includes('Other')"
              >
                <label class="d-block text-left text-bold"
                  >Please specify</label
                >
                <b-form-input
                  placeholder="Enter the type of the ingredient"
                  v-model="additionalType"
                >
                </b-form-input>
              </b-form-group>
              <b-alert
                dismissible
                style="width: 100%"
                v-model="emptyTypeAlert"
                variant="danger"
              >
                Cannot be empty!
              </b-alert>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group class="text-left">
              <label
                title="Some keywords that capture important aspects of the ingredient"
                v-b-tooltip.hover.bottom
                >Keywords</label
              >
              <!-- <b-form-input id="input-2" v-model="form.keywords"  rows-6></b-form-input>-->
              <tags-input
                :typeahead="true"
                element-id="keywords"
                placeholder="  Some keywords that capture important aspects of the ingredient"
                v-model="form.keywords"
              >
              </tags-input>
              <p
                class="text-left font-italic"
                style="color: red; font-size: 14px"
              >
                * Press enter after each keyword.
              </p>
            </b-form-group>
            <b-form-group class="text-left">
              <label
                title="Information that you may wish to include and does not naturally fit elsewhere, should be put here"
                v-b-tooltip.hover.bottom
                >Notes</label
              >
              <textarea
                class="col-12 form-control"
                placeholder="Information that you may wish to include and does not naturally fit elsewhere, should be put here"
                rows="4"
                v-model="form.notes"
              >
              </textarea>
            </b-form-group>
          </b-col>
        </b-row>

        <hr />
        <!-- content and resource URLs -->
        <b-row>
          <b-col class="text-left" cols="6">
            <!--          <h5 class="text-left">Select the file you want to upload or enter the URLs for the resource</h5>-->
            <h5>
              <span
                title="The content material of the ingredient. This may refer to a document or image uploaded by the user or include a link to an external resource (video, webpage etc)"
                v-b-tooltip.hover.bottom
                >Content
              </span>
            </h5>
          </b-col>
        </b-row>
        <b-row class="mt-2 mb-6">
          <b-col cols="6">
            <!-- add content  -->
            <b-form-group>
              <label class="d-block text-left text-bold">Upload a file</label>
              <b-form-file
                :state="Boolean(file)"
                class="text-left"
                drop-placeholder="Drop file here..."
                placeholder="Browse your files..."
                v-model="file"
              >
              </b-form-file>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group>
              <label class="d-block text-left text-bold"
                >... or enter a URL for an external file</label
              >
              <b-form-input
                placeholder="Enter the ingredient's URL"
                rows-6
                v-model="form.url"
              >
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row class="mt-2 mb-6">
          <b-col class="text-left col-6">
            <label
              title="Language of the ingredient's content, if relevant"
              v-b-tooltip.hover.bottom
              >Language (Hold <strong>Ctrl</strong> to select multiple
              values)</label
            >
            <select
              multiple
              style="height: 200px"
              class="custom-select d-block w-100"
              v-model="form.contentLanguage"
            >
              <option disabled value="">Select Language</option>
              <option value="Arabic">Arabic</option>
              <option value="Chinese">Chinese</option>
              <!--                <option value="Dari">Dari</option>-->
              <option value="English">English</option>
              <option value="Finnish">Finnish</option>
              <option value="French">French</option>
              <option value="German">German</option>
              <option value="Greek">Greek</option>
              <!--                <option value="Hindi">Hindi</option>-->
              <option value="Italian">Italian</option>
              <!--                <option value="Russian">Russian</option>-->
              <option value="Spanish">Spanish</option>
              <!--                <option value="Ukrainian">Ukrainian</option>-->
              <option value="Other">Other (specify)</option>
            </select>
            <b-form-group
              class="mt-2"
              v-if="this.form.contentLanguage.includes('Other')"
            >
              <label class="d-block text-left text-bold">Please specify</label>
              <b-form-input
                placeholder="Enter the language of the ingredient"
                v-model="additionalLanguage"
              >
              </b-form-input>
            </b-form-group>
          </b-col>

          <b-col class="text-left col-6">
            <label
              title="Choose a Creative Commons copyright license (see creativecommons.org/licenses/) or write down some other license that applies to the content of the ingredient"
              v-b-tooltip.hover.bottom
              >License <span class="text-danger">*</span>
            </label>
            <select
              class="custom-select d-block w-100"
              v-model="form.ingredientLicense[0]"
            >
              <option disabled value="">Select Ingredient license</option>
              <option :title="CC_BY" value="CC BY">CC BY</option>
              <option :title="CC_BY_SA" value="CC BY-SA">CC BY-SA</option>
              <option :title="CC_BY_ND" value="CC BY-ND">CC BY-ND</option>
              <option :title="CC_BY_NC" value="CC BY-NC">CC BY-NC</option>
              <option :title="CC_BY_NC_SA" value="CC BY-NC-SA">
                CC BY-NC-SA
              </option>
              <option :title="CC_BY_NC_ND" value="CC BY-NC-ND">
                CC BY-NC-ND
              </option>
              <option title="Other" value="Other">Other (specify)</option>
            </select>
            <b-form-group
              class="mt-2"
              v-if="this.form.ingredientLicense.includes('Other')"
            >
              <label class="d-block text-left text-bold">Please specify</label>
              <b-form-input
                placeholder="Enter the license of the ingredient"
                v-model="additionalLicense"
              >
              </b-form-input>
            </b-form-group>
            <b-alert
              dismissible
              style="width: 100%"
              v-model="emptyIngredientLicenseAlert"
              variant="danger"
            >
              Cannot be empty!
            </b-alert>

            <div class="mt-2">
              <label
                title="The media type of the content"
                v-b-tooltip.hover.bottom
              >
                Media type <span class="text-danger">*</span>
              </label>
              <select
                class="custom-select d-block w-100"
                id="ingredientMediaType"
                v-model="form.mediaType"
              >
                <option disabled value="">Select media type</option>
                  <v-for "mediaType in definedMediaTypes">
                  	<option :value="mediaType.label">{{mediaType.label}}</option>
              </select>
              <b-alert
                dismissible
                style="width: 100%"
                v-model="emptyMediaTypeAlert"
                variant="danger"
              >
                Cannot be empty!
              </b-alert>
            </div>
          </b-col>
        </b-row>

        <hr />

        <b-row class="my-container" style="margin-bottom: 20px">
          <h5
            class="float-left ml-3"
            title="The organisations that were involved in originally producing the content of this ingredient, if relevant"
            v-b-tooltip.hover.bottom
          >
            Creators
          </h5>
        </b-row>
        <b-row class="text-left"> </b-row>

        <div class="col-12 row my-container">
          <b-row>
            <b-col class="text-left" cols="5">
              <p>
                <strong
                  >(i) Search for an existing organisation and add it as a
                  creator of this ingredient
                </strong>
              </p>
            </b-col>
            or
            <b-col class="text-left" cols="3">
              <p>
                <strong>
                  (ii) Register a new organisation and add it as a
                  creator</strong
                >
              </p>
            </b-col>
            <b-col class="text-left" cols="3">
              <b-button
                @click="addNewCollaboratorForm"
                class="btn bg-orange btn-sm"
              >
                <span style="cursor: pointer; color: green" title="Add new">
                  <font-awesome-icon icon="plus" />
                </span>
                Add new creator
              </b-button>
            </b-col>
          </b-row>
          <div
            :key="index"
            class="col-12 row my-container"
            v-for="(collaborator, index) in creatorsWithId"
          >
            <label>Creator {{ index + 1 }}</label>
            <b-form-group class="col-4 my-container">
              <b-form-input
                @click="searchForCollaborator(index)"
                placeholder="Search creator"
                type="text"
                v-model="chosenCollaboratorName[index]"
              >
              </b-form-input>
            </b-form-group>

            <!--          <b-form-group class="col-4 my-container">-->
            <!--            <b-form-input-->
            <!--              placeholder="Collaborator Type"-->
            <!--              readonly-->
            <!--              v-model="chosenCollaboratorType[index]">-->
            <!--            </b-form-input>-->
            <!--          </b-form-group>-->

            <span>
              <b-button
                @click="modalOrgShow = !modalOrgShow"
                class="btn bg-orange btn-sm"
                style="
                  cursor: pointer;
                  margin-left: 45px;
                  margin-bottom: 0px;
                  color: red;
                "
                title="Create new organisation"
                v-show="!chosenCollaboratorName[index]"
              >
                Create new organisation
              </b-button>
              <b-modal hide-footer size="xl" static v-model="modalOrgShow"
                ><CreateNewOrganization></CreateNewOrganization
              ></b-modal>
            </span>

            <b-form-group style="margin-left: 20px; margin-top: 6px">
              <span
                @click="deleteCollaborator(index)"
                style="cursor: pointer; margin-bottom: 0; color: red"
                title="Delete"
              >
                <font-awesome-icon icon="trash-alt" />
              </span>
            </b-form-group>

            <b-form-group style="margin-left: 20px; margin-top: 6px">
              <span
                @click="addNewCollaboratorForm"
                style="cursor: pointer; margin-bottom: 0; color: green"
                title="Add new"
              >
                <font-awesome-icon icon="plus" />
              </span>
            </b-form-group>
          </div>
        </div>

        <b-row class="p-3">
          <div class="col-12 row my-container">
            <p class="mb-0">
              <span class="col-3 mr-5"
                ><strong
                  >Do you want to add a non existing creator?</strong
                ></span
              >
              <a
                @click.prevent="addNewNonExistingCreator"
                class="text-orange"
                href="#"
                >Add new</a
              >
            </p>
            <b-row
              :key="index"
              class="mt-3 col-12"
              v-for="(creator, index) in creators"
            >
              <label>Creator {{ index + 1 }}</label>
              <b-col>
                <b-form-input
                  placeholder="Enter the creator's name"
                  v-model="creators[index].name"
                >
                </b-form-input>
                <select
                  class="mt-2 custom-select d-block w-100"
                  v-model="creators[index].type"
                >
                  <!--                  <option disabled value="">Select type</option>-->
                  <option value="Central government">Central government</option>
                  <option value="Charity or foundation">
                    Charity or foundation
                  </option>
                  <option value="For-profit organisation">
                    For-profit organisation
                  </option>
                  <option value="GLAM">GLAM</option>
                  <option value="Informal group or association">
                    Informal group or association
                  </option>
                  <option value="International body">International body</option>
                  <option value="Local government">Local government</option>
                  <option value="Non-Governmental Organisation">
                    Non-Governmental Organisation
                  </option>
                  <option value="Regional government">
                    Regional government
                  </option>
                  <option value="Religious institutions">
                    Religious institutions
                  </option>
                  <option value="School">School</option>
                  <option value="University or research institute">
                    University or research institute
                  </option>
                  <option value="Other">Other</option>
                </select>
              </b-col>
              <b-col>
                <b-textarea
                  placeholder="Enter the creator's description"
                  style="height: 84px"
                  v-model="creators[index].description"
                >
                </b-textarea>
              </b-col>
              <span class="mt-4">
                <span
                  @click="addNewNonExistingCreator"
                  style="cursor: pointer; color: green"
                  title="Add new"
                >
                  <font-awesome-icon icon="plus" />
                </span>
                <span
                  @click="deleteNonExistingCreator(index)"
                  class="ml-2"
                  style="cursor: pointer; color: red"
                  title="Delete"
                >
                  <font-awesome-icon icon="trash-alt" />
                </span>
              </span>
            </b-row>
          </div>
        </b-row>

        <hr />

        <b-row align-h="start" class="ml-3">
          <h6><span class="text-danger">*</span> Required field</h6>
        </b-row>

        <b-row>
          <b-alert
            dismissible
            style="width: 100%"
            v-model="showDismissibleAlert"
            variant="danger"
          >
            You must fill in all the required fields!
          </b-alert>
        </b-row>

        <b-row align-h="center">
          <div class="text-cent mt-2">
            <b-button @click="hideModal" class="link">Cancel</b-button>
            <button @click="checkForm" class="btn bg-orange" type="button">
              Save
            </button>
          </div>
        </b-row>
      </div>
    </b-container>
  </div>
  <div v-else>
    <NoAccess />
  </div>
</template>

<script>
import SearchPlugin from "../../plugins/SearchPlugin";
import { mapGetters } from "vuex";
import { eventBus } from "../../main";
import CreateNewOrganization from "../organizations/CreateNewOrganization";
import NoAccess from "../NoAccess";
import {mediaTypes} from '../../data.js'

export default {
  data() {
    return {
      CC_BY:
        "Attribution: This license lets others distribute, remix, adapt, and build upon your work, even commercially, as long as they credit you for the original creation. This is the most accommodating of licenses offered. Recommended for maximum dissemination and use of licensed materials.",
      CC_BY_SA:
        "Attribution-ShareAlike: This license lets others remix, adapt, and build upon your work even for commercial purposes, as long as they credit you and license their new creations under the identical terms. This license is often compared to “copyleft” free and open source software licenses. All new works based on yours will carry the same license, so any derivatives will also allow commercial use.",
      CC_BY_ND:
        "Attribution-NoDerivs: This license lets others reuse the work for any purpose, including commercially; however, it cannot be shared with others in adapted form, and credit must be provided to you.",
      CC_BY_NC:
        "Attribution-NonCommercial: This license lets others remix, adapt, and build upon your work non-commercially, and although their new works must also acknowledge you and be non-commercial, they don’t have to license their derivative works on the same terms.",
      CC_BY_NC_SA:
        "Attribution-NonCommercial-ShareAlike: This license lets others remix, adapt, and build upon your work non-commercially, as long as they credit you and license their new creations under the identical terms.",
      CC_BY_NC_ND:
        "Attribution-NonCommercial-NoDerivs: This license is the most restrictive of our six main licenses, only allowing others to download your works and share them with others as long as they credit you, but they can’t change them in any way or use them commercially.",

      definedMediaTypes: mediaTypes,
      modalOrgShow: false,
      showModal: false,
      file: null,
      collaboratorsExist: false,
      chosenCollaboratorName: [],
      chosenCollaboratorType: [],
      resourceCollaborators: {},
      resourceCollaboratorsArray: [],
      showDismissibleAlert: false,
      emptyTitleAlert: false,
      emptyDescriptionAlert: false,
      emptyMediaTypeAlert: false,
      emptyIngredientLicenseAlert: false,
      emptyResourceTypeAlert: false,
      emptySelectedFocusAreasAlert: false,
      emptyTypeAlert: false,
      selectedFocusAreas: [], // Must be an array reference!
      selectedFocusAreas2: [], // Must be an array reference!
      publicReadable: false,
      additionalFocusArea: "",
      additionalLanguage: "",
      additionalLicense: "",
      additionalType: "",
      sTerm: "", // Search integration addition
      FocusAreaOptions: [
        { text: "Arts and heritage", value: "Arts and heritage" },
        { text: "Community development", value: "Community development" },
        { text: "Education", value: "Education" },
        { text: "Human rights", value: "Human rights" },
        {
          text: "Intercultural understanding",
          value: "Intercultural understanding",
        },
        {
          text: "Interreligious understanding",
          value: "Interreligious understanding",
        },
        { text: "Job placement/employment", value: "Job placement/employment" },
        {
          text: "Leisure and entertainment",
          value: "Leisure and entertainment",
        },
        { text: "Skills development", value: "Skills development" },
        { text: "Social inclusion", value: "Social inclusion" },
        { text: "Other", value: "Other" },
      ],
      selectedKeywords: [],
      form: {
        title: "",
        description: "",
        notes: "",
        license: [],
        url: "",
        thumbnailUrl: "",
        mediaType: "",
        contentLanguage: [],
        resourceType: [],
        ingredientLicense: [],
        publicReadable: false,
        keywords: [],
      },
      creatorsWithId: [{ id: 0 }],
      creators: [{}],
    };
  },
  props: ["showModal"],
  components: {
    NoAccess,
    CreateNewOrganization,
  },
  created() {
    eventBus.$on("hideOrgModal", (hideOrgModal) => {
      this.modalOrgShow = hideOrgModal;
    });
    eventBus.$on("organizationTitle", (organizationTitle) => {
      this.chosenCollaboratorName.push(organizationTitle);
    });
    eventBus.$on("organizationId", (organizationId) => {
      this.resourceCollaborators["id"] = organizationId;
      this.resourceCollaboratorsArray.push(this.resourceCollaborators);
      this.resourceCollaborators = {};
    });
  },
  computed: {
    ...mapGetters(["authenticatedUser"]),
    FocusM() {
      let FocusM = this.selectedFocusAreas;
      return FocusM;
    },
    publicReadableVal() {
      let publicReadableVal = false;
      if (this.form.publicReadable !== false) {
        publicReadableVal = true;
      }
      if (this.form.publicReadable === undefined) {
        publicReadableVal = false;
      }
      return publicReadableVal;
    },
    NewKeywordsArray() {
      let NewKeywordsArray = [];
      for (let i = 0; i < this.form.keywords.length; i++) {
        NewKeywordsArray.push(this.form.keywords[i].value);
      }
      return NewKeywordsArray;
    },
  },
  beforeMount() {
    SearchPlugin.event.$on("updateterm", this.changeTerm);
    SearchPlugin.event.$on("showView", this.showView);
  },
  methods: {
    initializeCollaborators() {
      this.creatorsWithId = [{ id: 0 }];
      this.collaboratorsExist = true;
    },
    searchForCollaborator(index) {
      eventBus.$emit("forgetGlobalSearch", null);
      this.searchCategory("Organisations");
      this.position = index;
    },
    checkForm() {
      // Re-initialize alerts in case the user tries again
      this.showDismissibleAlert = false;
      this.emptyTitleAlert = false;
      this.emptyDescriptionAlert = false;
      this.emptyMediaTypeAlert = false;
      this.emptyIngredientLicenseAlert = false;
      this.emptyResourceTypeAlert = false;
      this.emptySelectedFocusAreasAlert = false;
      this.emptyTypeAlert = false;

      // Additional Focus Area handle
      if (
        this.selectedFocusAreas.includes("Other") &&
        this.FocusM[this.FocusM.length - 1] !== this.additionalFocusArea
      ) {
        this.FocusM.push(this.additionalFocusArea);
      }

      // Additional Language handle
      if (
        this.form.contentLanguage.includes("Other") &&
        this.form.contentLanguage[this.form.contentLanguage.length - 1] !==
          this.additionalLanguage
      ) {
        this.form.contentLanguage.push(this.additionalLanguage);
      }

      // Additional License handle
      if (
        this.form.ingredientLicense.includes("Other") &&
        this.form.ingredientLicense[this.form.ingredientLicense.length - 1] !==
          this.additionalLicense
      ) {
        this.form.ingredientLicense.push(this.additionalLicense);
      }

      // Additional Type handle
      if (
        this.form.resourceType.includes("Other") &&
        this.form.resourceType[this.form.resourceType.length - 1] !==
          this.additionalType
      ) {
        this.form.resourceType.push(this.additionalType);
      }

      // Creators without ID handle
      for (let i = 0; i < this.creators.length; i++) {
        if (!this.creators[i].name && !this.creators[i].description) {
          this.creators.splice(i, 1);
          i--;
        }
      }
      // check if all required fields are filled
      if (
        !this.form.title ||
        !this.form.description ||
        !this.form.mediaType ||
        this.form.ingredientLicense.length === 0 ||
        this.form.resourceType.length === 0 ||
        this.selectedFocusAreas.length === 0
      ) {
        this.showDismissibleAlert = true;
        if (!this.form.title) {
          this.emptyTitleAlert = true;
        }
        if (!this.form.description) {
          this.emptyDescriptionAlert = true;
        }
        if (!this.form.mediaType) {
          this.emptyMediaTypeAlert = true;
        }
        if (this.form.ingredientLicense.length === 0) {
          this.emptyIngredientLicenseAlert = true;
        }
        if (!this.selectedFocusAreas) {
          this.emptyResourceTypeAlert = true;
        }
        if (this.FocusM.length === 0) {
          this.emptySelectedFocusAreasAlert = true;
        }
        if (this.form.resourceType.length === 0) {
          this.emptyTypeAlert = true;
        }
      } else {
        this.registerResource();
      }
    },
    showMsgSuccess() {
      this.boxOne = "";
      this.$bvModal
        .msgBoxOk("Your ingredient has been successfully created.", {
          okVariant: "success",
        })
        .then((value) => {
          this.boxOne = value;
          if (this.boxOne) {
            eventBus.$emit("hideModal", this.showModal);
          } else {
          }
        });
      // .catch(error => {
      //   alert('An error occurred! Please refresh the page.' + error)
      // })
    },
    showMsgFail() {
      this.boxOne = "";
      this.$bvModal
        .msgBoxOk("Something went wrong. Please try again.", {
          okVariant: "danger",
        })
        .then((value) => {
          this.boxOne = value;
          if (this.boxOne) {
            window.location.reload();
          } else {
          }
        });
      // .catch(error => {
      //   alert('An error occurred! Please refresh the page.' + error)
      // })
    },
    deleteCollaborator(index) {
      this.creatorsWithId.splice(index, 1);
      this.resourceCollaboratorsArray.splice(index, 1);
      this.chosenCollaboratorName.splice(index, 1);
      this.chosenCollaboratorType.splice(index, 1);
    },
    addNewCollaboratorForm() {
      this.creatorsWithId.push({});
    },
    addNewNonExistingCreator() {
      this.creators.push({
        type: "GLAM (Galleries, Libraries, Archives, Museums)",
      });
    },
    deleteNonExistingCreator(index) {
      this.creators.splice(index, 1);
    },
    registerResource() {
      // Register the resource using the API
      let InputResourceData = {
        creatorsWithId: this.resourceCollaboratorsArray,
        creators: this.creators,
        title: this.form.title,
        publicReadable: this.publicReadable,
        description: this.form.description,
        metadataLanguage: "string",
        areasOfFocus: this.FocusM,
        notes: this.form.notes,
        keywords: this.NewKeywordsArray,
        mediaType: this.form.mediaType,
        license: this.form.ingredientLicense,
        contentLanguage: this.form.contentLanguage,
        mimeType: "string",
        resourceType: this.form.resourceType,
        url: this.form.url,
        thumbnailUrl: this.form.thumbnailUrl,
      };

      this.$store
        .dispatch("createResource", InputResourceData)
        .then((resource) => {
          if (resource) {
            // Create the resource and then, upload the content if the file exists
            if (this.file !== null) {
              let formData = new FormData();
              formData.append("file", this.file);
              let params = { id: resource.id, file: formData };
              this.$store
                .dispatch("uploadResourceContent", params)
                .then((data) => {
                  this.showMsgSuccess();
                  eventBus.$emit("resourceTitle", resource.title);
                  eventBus.$emit("resourceId", resource.id);
                })
                .catch((error) => {
                  console.info(error);
                  this.showMsgFail();
                });
            } else {
              this.showMsgSuccess();
              eventBus.$emit("resourceTitle", resource.title);
              eventBus.$emit("resourceId", resource.id);
            }
          } else {
            this.showMsgFail();
          }
        })
        .catch((error) => {
          console.info(error);
          this.showMsgFail();
        });
    },
    hideModal() {
      eventBus.$emit("hideModal", this.showModal);
    },
    GoAway() {
      this.$store.dispatch("logout");
    },
    changeTerm(val) {
      this.sTerm = val;
    },
    showAll: function (token) {
      this.$search.searchNow();
    },
    showSearch: function () {
      this.$search.toggleSearch();
    },
    initOrg: function () {
      this.organisation = {};
    },
    showView: function (event) {
      this.$store
        .dispatch("getOrganizationEntity", event.detail.id)
        .then((data) => {
          this.initOrg();
          this.organisation = data;
          if (this.resourceCollaboratorsArray[this.position] == null) {
            this.chosenCollaboratorName.push(this.organisation.name);
            this.chosenCollaboratorType.push(this.organisation.type);
            this.resourceCollaborators["id"] = event.detail.id;
            this.resourceCollaboratorsArray.push(this.resourceCollaborators);
            this.resourceCollaborators = {};
          } else {
            this.resourceCollaboratorsArray.splice(this.position, 1);
            this.chosenCollaboratorName.splice(
              this.position,
              1,
              this.organisation.name
            );
            this.chosenCollaboratorType.splice(
              this.position,
              1,
              this.organisation.type
            );
            this.resourceCollaborators["id"] = event.detail.id;
            this.resourceCollaboratorsArray.push(this.resourceCollaborators);
            this.resourceCollaborators = {};
          }
        })
        .catch((error) => {
          console.info(error);
        });
    },
    searchCategory: function (cat_type, token) {
      this.$search.searchNow({
        resulttype: cat_type,
        token: token,
      });
    },
    searchTerm: function (term, resulttype, token) {
      this.$search.searchNow({
        term: term,
        resulttype: resulttype,
        token: token,
      });
    },
  },
};
</script>

<style module>
.totheleft {
  float: left;
}

.custom-control {
  float: left;
  width: 100%;
}

.form-group.required > label:after {
  content: " *";
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/resources/CreateNewResource.vue